<div class="container text-center" *ngIf="!loggedIn">
    <img src="assets/images/logo-mapfre.png" alt="" style="width:50%">
    <h1 style="margin-top:1em;">
        <mat-label style="font-size: 1em;font-weight: bold;color: #d81e05;">
            {{ 'LANDING.TITLE' | translate }}
        </mat-label>
    </h1>
    <button mat-raised-button color="primary" (click)="login()">Login</button>
</div>
<router-outlet></router-outlet>
